import React, { Component } from "react";
import styled from "styled-components";

import PropTypes from "prop-types";
import MenuIcon from "../assets/icons/MenuIcon";
import { colors } from "../themes/appTheme";

const MenuWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  svg {
    position: relative;
    left: 0;
  }
`;

const Title = styled.h1`
  font-size: 0.75rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  padding-bottom: 7px;
`;

const ImageWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 120px;
    transition: all 0.2s ease-out;
  }
`;

class Menu extends Component {
  static propTypes = {
    isMenuOpen: PropTypes.bool.isRequired,
    onMainMenuToggle: PropTypes.func.isRequired
  };

  render() {
    const { onMainMenuToggle } = this.props;

    return (
      <MenuWrapper>
        <ImageWrapper>
          <Title>React Course by</Title>
          <a href="https://www.codecamps.com">
            <img src="/codecamps-logo.png" alt="Codecamps Logo" />
          </a>
        </ImageWrapper>
        <MenuIcon color={colors.primaryDarkLight} onClick={onMainMenuToggle} />
      </MenuWrapper>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/headers/Menu.js